import React from 'react'
import './loader.scss'

const LoaderPartial = ({ texto }) => {
  return (
    <div className='custom-loader__inner-wrapper'>
      <div className='custom-loader'>
        <div>
          <span className='texto-procesando'>PROCESANDO</span>
        </div>
        <div className='loader-container'>
          <div className='loader'></div>
          <div className='loader2'></div>
        </div>
        <div className='texto-personalizado-container'>
          <span className='texto-personalizado'>{texto}</span>
        </div>
        <div className='estado-personalizado-container'>
          <span id='custom-loader__estado-personalizado' className='estado-personalizado'></span>
        </div>
      </div>
    </div>
  )
}

export default React.memo(LoaderPartial)
